import request from '@/utils/request'

const baseUrl = '/erp/purchase/report/purchase-inbound-summary'

export const pagePurchaseInboundSummaryReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listPurchaseInboundSummarySupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportPurchaseInboundSummaryReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
